export class File {
    public id: number;
    public size: string;
    public icon: string;
    public file: any;
}
